import React, { createContext, useContext } from 'react';
import type { RegistryManager } from 'edge-stream-js-react';

const RegistryManagerContext = createContext<RegistryManager | null>(null);

export function RegistryManagerProvider({
  manager,
  children,
}: {
  manager: RegistryManager;
  children: React.ReactNode;
}) {
  return (
    <RegistryManagerContext.Provider value={manager}>
      {children}
    </RegistryManagerContext.Provider>
  );
}

export function useRegistryManager(): RegistryManager {
  const ctx = useContext(RegistryManagerContext);
  if (!ctx) {
    throw new Error('useRegistryManager must be used within <RegistryManagerProvider>');
  }
  return ctx;
}
